import React, { useState, useEffect } from "react";
import { registerPopupControls } from "./loadingPopupManager";
import LoadingIllustration from "../fragments/IllustrationState/LoadingIllustration";

const LoadingPopup = () => {
    const [visible, setVisible] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("Please wait, preparing your data...");

    useEffect(() => {
        registerPopupControls(
            (msg: string) => {
                setMessage(msg);
                setVisible(true);
            },
            () => setVisible(false)
        );
    }, []);

    if (!visible) return null;

    return (
        <div
            style={{
                position: "fixed",
                zIndex: 999,
                width: "100vw",
                height: "100vh",
                display: "flex",
                background: "rgba(0, 0, 0, 0.7)",
            }}
        >
            <div
                style={{
                    background: "white",
                    width: "400px",
                    height: "400px",
                    borderRadius: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "auto",
                    animation: "popup 0.4s ease-out forwards",
                }}
            >
                <LoadingIllustration description={message} title="Preparing Data" />
            </div>
            <style>{`
                @keyframes popup {
                  0% {
                    opacity: 0;
                    transform: scale(0.8);
                  }
                  100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                }
              `}</style>
        </div>
    );
}

export default LoadingPopup;